import { Span } from "@chakra-ui/react"
import SearchCombobox, { ComboxActions } from "./SearchCombobox"
import Link from "@hydrologiq/shared/components/Link"

export type AssetItem = {
  id: string
  name: string
}

const AssetsCombobox = (props: {
  onItemSelection?: (value: AssetItem | undefined) => void
  assets?: AssetItem[]
  Actions?: ComboxActions
  CreateAction?: () => React.ReactNode
  valueId?: string | null
  disabled?: boolean
  required?: boolean
}) => {
  const { onItemSelection, assets: predefinedAssets, Actions, CreateAction, valueId, disabled, required } = props

  const defaultCreateAction = () => (
    <Link href="/assets" variant="primary">
      Create asset
    </Link>
  )

  return (
    <SearchCombobox<AssetItem>
      queryType="assets"
      staticItems={predefinedAssets}
      onItemSelection={onItemSelection}
      label="assets"
      valueId={valueId}
      disabled={disabled}
      required={required}
      itemContent={(item) => (
        <Span width="100%" alignItems="start" textStyle="sm" fontWeight="medium">
          {item.name}
        </Span>
      )}
      CreateAction={CreateAction || defaultCreateAction}
      Actions={Actions}
    />
  )
}

export default AssetsCombobox
